import _ from "underscore";
import { stateMerge } from "vue-object-merge";
import * as mutation from "./mutation-types";
import { userService } from "./service";
import { getEmptyUser, getEmptySignInDetails, dashboardHelper, getEmptyMfaChallengeAttempt } from "./helpers";
import { deepCopy } from "../helpers";

export const mutations = {
  [mutation.STATE_HIDE_ERROR](state, hideArgument) {
    stateMerge(state[hideArgument], { error: { show: false } });
  },

  [mutation.SIGN_IN_SET_REDIRECT](state, redirect) {
    state.user.redirect = redirect;
  },

  [mutation.SIGN_IN_SET_DATA](state, details) {
    stateMerge(state.user.data, details);
    state.user.error.show = false;
  },

  [mutation.SIGN_IN_CLEAR_PASSWORD](state) {
    state.user.data.password = "";
  },

  [mutation.SIGN_IN_STARTED](state) {
    state.user.error.show = false;
    state.user.busy = true;
  },

  [mutation.SIGN_IN_FAILED_MFA](state, error) {
    state.user.error.show = true;
    state.user.error.details = error;
    state.user.busy = false;
  },    

  [mutation.SIGN_IN_SUCCEEDED](state, userDetails) {
    state.user.details = userDetails;
    state.user.isSignedIn = true;
    state.user.busy = false;
    state.user.data = getEmptySignInDetails();
    state.user.mfaChallengeAttempt = getEmptyMfaChallengeAttempt();
    userService.setAuthForAllAxiosRequests(userDetails.token);
  },

  [mutation.SIGN_IN_FAILED](state, error) {
    state.user.error.show = true;
    state.user.error.details = error;
    state.user.busy = false;
  },

  [mutation.SIGN_IN_STARTED_REDIRECT_MFA_CHALLENGE](state, userDetails) {
    state.user.details = userDetails;
    state.user.redirect = "/mfa/attempt-challenge";
    state.user.error.show = false;
    state.user.busy = false;
  },

  [mutation.SIGN_IN_STARTED_MFA_CHALLENGE](state) {
    state.user.error.show = false;
    state.user.busy = true;
  },

  [mutation.SIGN_IN_STARTED_MFA_CHALLENGE_SUCCESSFUL](state, result) {
    state.user.busy = false;
    state.user.mfaChallengeAttempt = result;
  },

  [mutation.CHANGE_PASSWORD_STARTED](state) {
    state.user.error.show = false;
    state.user.busy = true;
  },
  [mutation.CHANGE_PASSWORD_SUCCEEDED](state, userDetails) {
    state.user.details = userDetails;
    state.user.isSignedIn = true;
    state.user.busy = false;
    userService.setAuthForAllAxiosRequests(userDetails.token);
  },
  [mutation.CHANGE_PASSWORD_FAILED](state, error) {
    state.user.error.show = true;
    state.user.error.details = error;
    state.user.busy = false;
  },

  [mutation.SIGN_OUT_SUCCEEDED](state) {
    state.user.details = getEmptyUser();
    state.user.mfaSignInDetails = getEmptyUser();
    state.user.mfaChallengeAttempt = getEmptyMfaChallengeAttempt();
    state.user.isSignedIn = false;
    state.user.busy = false;
  },
  [mutation.SIGN_OUT_FAILED](state, error) {
    state.user.details = getEmptyUser();
    state.user.mfaSignInDetails = getEmptyUser();
    state.user.mfaChallengeAttempt = getEmptyMfaChallengeAttempt();
    state.user.isSignedIn = false;
    state.user.error.show = true;
    state.user.error.details = error;
    state.user.busy = false;
  },

  [mutation.WIDGETS_INITIAL_SETUP](state) {
    const defaults = _(dashboardHelper.getDefaultWidgets()).map(w => ({
      widget: w,
      toggled: false
    }));
    state.widgets.data = {
      Vsl: deepCopy(defaults),
      Help: deepCopy(defaults),
      Upfront: deepCopy(defaults)
    };
  },
  [mutation.WIDGETS_GET_STARTED](state) {
    state.widgets.loading = true;
  },
  [mutation.WIDGETS_GET_SUCCEEDED](state, widgets) {
    state.widgets.loading = false;
    state.widgets.loaded = true;
    state.widgets.data = widgets;
  },
  [mutation.WIDGETS_GET_FAILED](state) {
    state.widgets.loading = false;
    state.widgets.loaded = false;
  },
  [mutation.WIDGETS_SAVE_STARTED](state, widgets) {
    state.widgets.processing = true;
    state.widgets.data = widgets;
  },
  [mutation.WIDGETS_SAVE_SUCCEEDED](state) {
    state.widgets.processing = false;
  },
  [mutation.WIDGETS_SAVE_FAILED](state) {
    state.widgets.processing = false;
  },
  [mutation.WIDGET_TOGGLE](state, { levyCollectionType, widget }) {
    const w = _(state.widgets.data[levyCollectionType]).find(w => w.widget == widget);
    if (w) w.toggled = !w.toggled;
  },
  [mutation.WIDGET_ADD](state, { levyCollectionType, widget }) {
    const widgets = state.widgets.data[levyCollectionType];
    widgets.push({ widget, toggled: false });
  },
  [mutation.WIDGET_REMOVE](state, { levyCollectionType, widget }) {
    const widgets = state.widgets.data[levyCollectionType];
    const index = _(widgets).findIndex(w => w.widget == widget);
    if (index >= 0) {
      widgets.splice(index, 1);
    }
  },
  [mutation.WIDGET_RESET](state, levyCollectionType) {
    state.widgets.data[levyCollectionType] = _(dashboardHelper.getDefaultWidgets()).map(w => ({
      widget: w,
      toggled: false
    }));
  },
  [mutation.WIDGET_MOVE_UP](state, { levyCollectionType, widget }) {
    const widgets = state.widgets.data[levyCollectionType];
    const index = _(widgets).findIndex(w => w.widget == widget);
    if (index > 0) {
      const item = widgets[index];
      widgets.splice(index, 1);
      widgets.splice(index - 1, 0, item);
    }
  },
  [mutation.WIDGET_MOVE_DOWN](state, { levyCollectionType, widget }) {
    const widgets = state.widgets.data[levyCollectionType];
    const index = _(widgets).findIndex(w => w.widget == widget);
    if (index > -1 && index < widgets.length) {
      const item = widgets[index];
      widgets.splice(index, 1);
      widgets.splice(index + 1, 0, item);
    }
  }
};
